/* eslint-disable no-dupe-keys */
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, TextField, Grid, Card, CardMedia } from "@mui/material";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet/dist/leaflet.css";
import { Icon, divIcon, point } from "leaflet";
import "../Offices/MapOffices/Style/map.css";
import { Link, useLocation } from "react-router-dom";
import "../Styles/Homepage.css";

import HomeHeader from "../Images/HomeImage/header.jpg";
import product from "../Images/17.jpg";
// import Transportation from "../Images/delivery.jpg";
// import UK from "../Images/united-kingdom.png";
// import Iraq from "../Images/iraq.png";
import Road from "../Images/HomeImage/2.jpg";
import Business from "../Images/imageTwo.jpg";
// import Rest from "../Images/HomeImage/13.jpg";
import Clearance from "../Images/HomeImage/custom-clearance.png";
import Price from "../Images/HomeImage/11.jpg";
import Delivery from "../Images/HomeImage/19.jpg";
// import Customer from "../Images/HomeImage/chat.png";
import payment from "../Images/HomeImage/3.jpg";
// import DeliveryVan from "../Images/HomeImage/11.jpg";
import { motion } from "framer-motion";
import ContactChat from "../Hellper/ContactChat";

import { message } from "antd";
import { useMediaQuery } from "@mui/material";
const Home = () => {
  // Inside your component
  const isMobile = useMediaQuery("(max-width:600px)");

  const fadeInVariant = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 1 },
  };
  const listItemVariant = {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    transition: { duration: 0.5, delay: 0.2 },
  };
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const [dataSource, setDataSource] = useState([]);
  const [searchCode, setSearchCode] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const mapRef = useRef(null);

  useEffect(() => {
    getApiProducts();
    const interval = setInterval(() => {
      getApiProducts();
    }, 600000);

    return () => clearInterval(interval);
  }, []);

  const getApiProducts = async () => {
    try {
      const productsRes = await fetch(`https://uktomars.co.uk/api/posts`);
      if (!productsRes.ok) {
        throw new Error(`HTTP error! Status: ${productsRes.status}`);
      }
      const productsData = await productsRes.json();
      setDataSource(
        productsData.map((item) => ({
          id: item.id,
          code: item.code,
          gps_id: item.gps_id,
          latitude: item.gps_device?.latitude,
          longitude: item.gps_device?.longitude,
          status: item.status,
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = () => {
    const location = dataSource.find((item) => item.code === searchCode);
    if (location) {
      if (location.status === 0 && location.latitude && location.longitude) {
        setSelectedLocation({
          lat: location.latitude,
          lng: location.longitude,
          code: location.code,
          status: location.status,
        });
        scrollToMap();
      } else if (location.status === 1) {
        setSelectedLocation({
          status: location.status,
          code: location.code,
        });
        scrollToMap();
      } else {
        setSelectedLocation(null);
        message.success("Location not found!");
      }
    } else {
      setSelectedLocation(null);
      message.error("Location not found!");
    }
  };

  const scrollToMap = () => {
    mapRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const customIcon = new Icon({
    iconUrl: require("../Offices/MapOffices/Image/marker-icon.png"),
    iconSize: [38, 38],
  });

  const createCustomClusterIcon = (cluster) => {
    return new divIcon({
      html: `<div class="cluster-icon">${cluster.getChildCount()}</div>`,
      className: "custom-marker-cluster",
      iconSize: point(33, 33, true),
    });
  };

  return (
    <div className="new-page">
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <header
          className="new-page-header"
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <img
              src={HomeHeader}
              alt="Header"
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "700px",
                // objectFit: "cover",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: { xs: 1, sm: 80 },
                left: 0,
                width: "100%",
                height: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "flex-start", sm: "flex-start" },
                justifyContent: "flex-end",
                color: "#fff",
                textAlign: "left",
                padding: { xs: "8px", sm: 3 },
                "@media (max-width: 1024px)": {
                  padding: 2,
                },
                "@media (max-width: 600px)": {
                  padding: "8px",
                },
              }}
            >
              <Box
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  padding: { xs: "1px", sm: 3 },
                  borderRadius: "8px",
                  maxWidth: { xs: "95%", sm: "80%" },
                  width: { xs: "47%", sm: "auto" },
                  marginLeft: { xs: "2px", sm: 0 },
                }}
              >
                <motion.div {...listItemVariant}>
                  {/* Hide this Box component on mobile */}
                  <Box
                    component="h1"
                    sx={{
                      fontSize: { xs: "1.2rem", sm: "2.5rem" },
                      fontWeight: "bold",
                      marginBottom: { xs: "8px", sm: 2 },
                      color: "#fff",
                      lineHeight: { xs: 1.2, sm: 1.5 },
                      display: { xs: "none", sm: "block" }, // Hide on mobile, show on larger screens
                    }}
                  >
                    Track Your Shipment
                  </Box>

                  <Box
                    component="form"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: "8px", sm: 2 },
                      marginTop: { xs: "8px", sm: 4 },
                      flexDirection: { xs: "column", sm: "row" },
                      width: { xs: "100%", sm: "auto" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      placeholder={
                        isMobile ? "Track Your Shipment" : "Tracking Number"
                      }
                      inputProps={{
                        "data-mobile-placeholder": "Enter tracking #", // Custom mobile placeholder
                      }}
                      variant="outlined"
                      value={searchCode}
                      onChange={(e) => setSearchCode(e.target.value)}
                      sx={{
                        width: { xs: "100%", sm: 400 },
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            borderColor: "transparent",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "transparent",
                          },
                          height: { xs: "36px", sm: "auto" },
                        },
                        "& .MuiInputBase-input": {
                          padding: { xs: "8px 12px", sm: "16.5px 14px" },
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          "&::placeholder": {
                            "@media (max-width: 600px)": {
                              content: '"Enter tracking #"', // Override placeholder on mobile
                            },
                          },
                        },
                        "@media (max-width: 600px)": {
                          "& .MuiInputBase-input::placeholder": {
                            content: '"Enter tracking #"',
                            opacity: 1,
                          },
                        },
                      }}
                    />

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSearch}
                      sx={{
                        backgroundColor: "#D84040",
                        padding: { xs: "6px 12px", sm: "10px 20px" },
                        fontWeight: "bold",
                        color: "white",
                        border: "none",
                        width: { xs: "100%", sm: "auto" },
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                        minWidth: { xs: "unset", sm: "64px" },
                        "&:hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                    >
                      {"Track"}
                    </Button>
                  </Box>
                </motion.div>
              </Box>
            </Box>
          </Box>
        </header>
      </Box>

      <main className="new-page-content">
        {/* Map Section */}
        <div ref={mapRef}>
          {selectedLocation && selectedLocation.status === 0 && (
            <MapContainer
              center={[selectedLocation.lat, selectedLocation.lng]}
              zoom={15}
              style={{ height: "500px", marginTop: "20px" }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <MarkerClusterGroup
                chunkedLoading
                iconCreateFunction={createCustomClusterIcon}
              >
                <Marker
                  position={[selectedLocation.lat, selectedLocation.lng]}
                  icon={customIcon}
                >
                  <Popup>Code: {selectedLocation.code}</Popup>
                </Marker>
              </MarkerClusterGroup>
            </MapContainer>
          )}

          {selectedLocation && selectedLocation.status === 1 && (
            <Box
              sx={{
                marginTop: "10px",
                textAlign: "center",
                fontSize: "1.25rem",
                color: "#2E7D32",
                fontWeight: 500,
                backgroundColor: "#E8F5E9",
                padding: "46px",
                borderRadius: "12px",
                border: "2px solid #66BB6A",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <span role="img" aria-label="success">
                ✅
              </span>
              {"Your item has been successfully delivered!"}
            </Box>
          )}
        </div>
        {/* //TODO: Products */}
        <div>
          <motion.div {...fadeInVariant}>
            <div className="divH1">Product Ranges</div>
          </motion.div>

          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <Card
                sx={{
                  p: 2,
                  borderRadius: 2,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={product}
                  alt="Product Ranges"
                  sx={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "500px",
                    objectFit: "contain",
                    borderRadius: 1,
                    mx: "auto",
                    display: "block",
                  }}
                />
              </Card>
            </Grid>
          </Grid>
        </div>
        {/* Transportation Section */}
        {/* <motion.div {...listItemVariant}>
          <div className="transportation-section">
            <div className="transportation-image">
              <img src={Transportation} alt="Transportation" />
            </div>
            <div className="transportation-details">
              <div className="divH1">{t("internationalTransportation")}</div>
              <div className="transportation-grid">
                <div>
                  <ul>
                    <li>
                      <img src={UK} alt="UK" />
                    </li>
                    <Link
                      to="/UKOffices"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <li className="item-title">{t("uk")}</li>
                    </Link>
                  </ul>
                </div>

                <div>
                  <ul>
                    <li>
                      <img src={Iraq} alt="Iraq" />
                    </li>
                    <Link
                      to="/IraqOffice"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <li className="item-title">{t("kurdistanIraq")}</li>
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </motion.div> */}

        {/* //TODO: Our Services */}
        <div className="ServicesAndWhatWeOffer">
          <motion.div {...fadeInVariant}>
            <div className="divH1">{"Our Services"}</div>
          </motion.div>

          <div className="grid-container">
            <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Business}
                      alt="Wholesale"
                      className="image-icon"
                    />
                  </li>
                  <Link
                    to="/Wholesale_Distribution"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <li className="item-title">Wholesale Distribution</li>
                  </Link>
                  <li className="item-title2">
                    With strong supplier connections,we bring you competitive
                    prices and up-to-date stock lists
                  </li>
                </ul>
              </div>
            </motion.div>
            <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Road}
                      alt="Road Transport"
                      className="image-icon"
                    />
                  </li>
                  <Link
                    to="/Export_Services"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <li className="item-title">Export Services</li>
                  </Link>
                  <li className="item-title2">
                    We provide full export support to move goods from the UK to
                    your destination country.
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Rest}
                      alt="Shop in the UK"
                      className="image-icon"
                    />
                  </li>
                  <Link
                    to="/International_Transportation"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <li className="item-title">International Transportation</li>
                  </Link>
                  <li className="item-title2">
                    We run weekly departures from our UK warehouse to Middle
                    East{" "}
                  </li>
                </ul>
              </div>
            </motion.div> */}
            <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={payment}
                      alt="FIB Payment"
                      className="image-icon"
                    />
                  </li>
                  <Link
                    to="/Logistics_Storage_Solutions"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <li className="item-title">
                      Logistics & Storage Solutions{" "}
                    </li>
                  </Link>
                  <li className="item-title2">
                    We offer secure storage and flexible logistics services to
                    support your wholesale and export needs.
                  </li>
                </ul>
              </div>
            </motion.div>
            <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Clearance}
                      alt="Customs Clearance"
                      className="image-icon"
                    />
                  </li>
                  <Link
                    to="/Customs_Clearance"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <li className="item-title">Customs Clearance</li>
                  </Link>
                  <li className="item-title2">
                    We provide complete customs clearance services for all UK
                    exports and international shipments.
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={DeliveryVan}
                      alt="Local Delivery"
                      className="image-icon"
                    />
                  </li>
                  <Link
                    to="/LocalDelivery"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <li className="item-title">{t("localDelivery1")}</li>
                  </Link>
                  <li className="item-title">
                    {t("localDeliveryDescription")}
                  </li>
                </ul>
              </div>
            </motion.div>  */}
          </div>
        </div>

        {/* //TODO: What We Offer */}
        <div>
          <motion.div {...fadeInVariant}>
            <div className="divH1">
              Your Trusted Partner for Wholesale & Export
            </div>
          </motion.div>
          <div className="grid-container">
            <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Price}
                      alt="Lowest Price"
                      className="image-icon"
                    />
                  </li>
                  {/* <Link
                    to="/LowestPrice"
                    style={{ textDecoration: "none", color: "inherit" }}
                  > */}
                  <li className="item-title">
                    Competitive Pricing & Quality Assurance
                  </li>
                  {/* </Link> */}
                  <li className="item-title2">
                    Unbeatable wholesale prices with high-quality, trusted
                    brands—guaranteed.
                  </li>
                </ul>
              </div>
            </motion.div>
            <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Delivery}
                      alt="Fast Delivery"
                      className="image-icon"
                    />
                  </li>
                  <li className="item-title">
                    Customer Satisfaction & End-to-End Service
                  </li>
                  <li className="item-title2">
                    Enjoy hassle-free ordering, outstanding support, and
                    reliable door-to-door delivery with real-time shipment
                    tracking and dedicated customer care.
                  </li>
                </ul>
              </div>
            </motion.div>
            {/* <motion.div {...listItemVariant}>
              <div className="grid-cell">
                <ul className="item-UI">
                  <li className="item-icon">
                    <img
                      src={Customer}
                      alt="Customer Satisfaction"
                      className="image-icon"
                    />
                  </li>
                  <li className="item-title">{t("customerSatisfaction")}</li>
                  <li className="item-title">
                    {t("customerSatisfactionDescription")}
                  </li>
                </ul>
              </div>
            </motion.div> */}
          </div>
          {/* Add this section just before the closing </main> tag */}
          <motion.div {...fadeInVariant}>
            <div className="divH1">Get in Touch</div>
          </motion.div>

          <Box
            sx={{
              backgroundColor: "#f8f9fa",
              borderRadius: "16px",
              padding: { xs: "30px", md: "40px" },
              margin: "40px auto",
              maxWidth: "900px",
              textAlign: "center",
              boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
              border: "1px solid #e9ecef",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: { xs: "15px", sm: "30px" },
                marginBottom: "30px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Box
                  component="img"
                  src="https://cdn-icons-png.flaticon.com/512/561/561127.png" // Email icon
                  sx={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                  }}
                  alt="Email icon"
                />
                <Box
                  component="a"
                  href="mailto:sales@uktomars.co.uk"
                  sx={{
                    fontSize: { xs: "1.1rem", sm: "1.2rem" },
                    fontWeight: "600",
                    color: "#D84040",
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    "&:hover": {
                      textDecoration: "underline",
                      color: "#b53535",
                    },
                  }}
                >
                  sales@uktomars.co.uk
                </Box>
              </Box>

              <Box
                sx={{
                  height: { xs: "1px", sm: "50px" },
                  width: { xs: "80%", sm: "1px" },
                  backgroundColor: "#e0e0e0",
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Box
                  component="img"
                  src="https://cdn-icons-png.flaticon.com/512/220/220236.png" // WhatsApp icon
                  sx={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                  }}
                  alt="WhatsApp icon"
                />
                <Box
                  component="a"
                  href="https://wa.me/447564627910"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: { xs: "1.1rem", sm: "1.2rem" },
                    fontWeight: "600",
                    color: "#25D366", // WhatsApp green color
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    "&:hover": {
                      textDecoration: "underline",
                      color: "#1da851",
                    },
                  }}
                >
                  +44 7564 627910
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                fontSize: "1.2rem",
                color: "#555",
                lineHeight: "1.7",
                maxWidth: "700px",
                margin: "0 auto",
                padding: { xs: "0 10px", sm: "0" },
                background: "#fff",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
            >
              Once your account is approved, you'll receive our exclusive weekly
              product catalogue and promotions straight to your inbox and
              WhatsApp channel, helping you stay ahead with the latest offers
              and stock updates.
            </Box>
          </Box>
        </div>
      </main>
      <ContactChat />
    </div>
  );
};

export default Home;
